(function () {
    const $body = $('body'),
        editable = {
            $editableWrapper: $('.editable__wrapper'), // wrapper div, mandatory
            $editable: $('.editable__text'), // the text to be edit, mandatory
            $toggle: $('.editable__toggle'), // the toggle control, not mandatory
            $formField: null,
            requestNeeded: false, // define wither the edit needs an ajax confirmation or not defined by class added to wrapper (editable__request), not mandatory, in case its true you need to add (data-editable-link) to the editable text with the requested link value
            field: 'input', // data attribute (data-field) added to the wrapper define the field type to be generated (input, textarea), not mandatory
            link: null, // data attribute (data-editable-link) added to the wrapper define the ajax link
            maxChar: null, // define max char (this is helpful for integration with char-counter plugin)
            vPort: 'all', // the view port to make the edit in place work above
            isMobile: null,
            emptyPlaceholder: 'Click to edit', // default empty text
            addControls: false, // boolean value to add or not controls (save, reset) to the form, data attribute (data-use-controls) added to the wrapper
            useToggle: false, // boolean value, in case we have toggle, it should receive the trigger function
            isDefault: false, // boolean value, in case we already have a form.

            init() {
                $.each(this.$editable, (i, item) => {
                    let $this = $(item);
                    if ($this.text() === '') {
                        $this.text(this.emptyPlaceholder);
                    }
                });

                this.control();
                this.responsive();
            },

            control() {
                this.$editableWrapper.on('click', e => {
                    let $this = $(e.target);
                    this.$editableWrapper = $this.closest('.editable__wrapper');
                    this.useToggle = !!this.$editableWrapper.find('.editable__toggle').length;

                    if (!this.useToggle && $this.hasClass('editable__text')) {
                        this.edit($this);
                    } else if (this.useToggle && $this.hasClass('editable__toggle')) {
                        this.edit($this);
                    }
                });

                $body.on('click', '.editable__save', e => {
                    e.preventDefault();
                    let $this = $(e.target);
                    this.$editableWrapper = $this.closest('.editable__wrapper');
                    this.setData($this, editable.$editableWrapper.find('.editable__input').val());
                });

                $body.on('click', '.editable__reset', e => {
                    e.preventDefault();
                    let $this = $(e.target);
                    this.resetData($this);
                });

                $body.on('click', e => {
                    if (typeof e !== 'undefined') {
                        if (
                            !$(e.target).hasClass('editable__wrapper') &&
                            !$(e.target).closest('.editable__wrapper').length
                        ) {
                            this.$editableWrapper = $('.editable__wrapper.js--edit');
                            this.setData();
                        }
                    }
                });

                $body.on('keydown', '.editable__input', e => {
                    let $this = $(e.target),
                        keycode = e.keyCode;
                    switch (keycode) {
                        case 9: // tab -- move to the next element
                            break;
                        case 13: // enter -- save
                            e.preventDefault();
                            e.stopPropagation();
                            this.$editableWrapper = $this.closest('.editable__wrapper');
                            editable.$editableWrapper.find('.editable__save').trigger('click');
                            break;
                        case 27: // esc -- reset
                            e.preventDefault();
                            e.stopPropagation();
                            this.resetData($this);
                            break;
                    }
                });

                $body.on('keydown', '.editable__toggle', e => {
                    let $this = $(e.target),
                        keycode = e.keyCode;
                    switch (keycode) {
                        case 13: // enter -- edit mode
                            setTimeout(() => {
                                $this.trigger('click');
                            }, 10);
                    }
                });
            },

            responsive() {
                if (this.vPort !== 'all') {
                    $(document).on(this.vPort + '-off', () => {
                        // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                        if (this.isMobile === null || this.isMobile === true) {
                            this.control();
                        }
                        this.isMobile = false;
                    });
                    $(document).on(this.vPort + '-on', () => {
                        // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                        if (this.isMobile === null || this.isMobile === false) {
                            this.disable();
                        }
                        this.isMobile = true;
                    });
                }
            },

            disable() {
                this.$editableWrapper.off('click');
                $body.off('click', '.editable__save, .editable__reset');
            },

            edit($this) {
                this.setData();

                this.$toggle = this.$editableWrapper.find('.editable__toggle');
                this.$editable = this.$editableWrapper.find('.editable__text');
                this.field =
                    typeof this.$editableWrapper.data('field') !== 'undefined'
                        ? this.$editableWrapper.data('field')
                        : 'input';

                let $form = editable.buildForm();

                this.$toggle.hide();
                this.$editable.hide().after($form);
                this.$editableWrapper.addClass('js--edit');
                this.$editableWrapper.find('.editable__input').focus();
            },
            formFields() {
                /* define a separate function, so it can be easy overwritten  */
                let $field = $('<input type="text" class="form-control"/>'),
                    $form = $(
                        '<form action="/" method="post"><div class="input-group"><div class="input-group__field-container--right-icon"></div></div></form>'
                    ),
                    $controlsWrapper = $('<span class="input-group-addon input-group-addon--right" ></span>'),
                    $controls = $(
                        '<button type="submit" class="btn editable__save"><i class="icon-checkmark"></i></button><button type="reset" class="btn editable__reset"><i class="icon-close_thin"></i></button>'
                    );

                if (this.field === 'textarea') {
                    $field = $(
                        '<textarea type="text" class="form-control" rows="5" cols="100" placeholder="Write a description"/>'
                    );
                    $controls = $(
                        '<div class="pull-right"><button type="reset" class="btn editable__reset">Cancel</button><button type="submit" class="btn editable__save">Save</button></div>'
                    );
                }

                return {$field, $form, $controlsWrapper, $controls};
            },
            buildForm() {
                let formFields = this.formFields(),
                    $formFieldsContainer = formFields.$form.find('.input-group__field-container--right-icon');
                formFields.$field.addClass('editable__input').val(this.$editable.html());

                $formFieldsContainer.append(formFields.$field);

                if (this.addControls) {
                    if (this.field === 'textarea') {
                        formFields.$form.append(formFields.$controls);
                    } else {
                        $formFieldsContainer.append(formFields.$controlsWrapper);
                        formFields.$controlsWrapper.append(formFields.$controls);
                    }
                }

                /* ***********integrating char-counter plugin ***********/
                if (
                    this.$editable.is('.charCount__text') &&
                    typeof this.$editable.attr('data-maxChar') !== 'undefined'
                ) {
                    this.maxChar = this.$editable.attr('data-maxChar');

                    if (formFields.$form.find('.input-group-addon--right').length === 0) {
                        $formFieldsContainer.append(formFields.$controlsWrapper);
                    }

                    formFields.$field.addClass('charCount__text').attr({
                        maxlength: this.maxChar,
                        'data-maxChar': this.maxChar,
                    });
                    formFields.$form.find('.input-group-addon--right').prepend('<span class="charLimit"></span>');
                    let $wrapper = formFields.$field.closest('.input-group');
                    UX.charCount.maxChar = this.maxChar;
                    UX.charCount.charLimitCount(formFields.$field, $wrapper);
                }
                /* ***********integrating char-counter plugin ***********/
                return formFields.$form;
            },
            setData($elem, textVal) {
                this.requestNeeded = this.$editableWrapper.is('.editable__request');
                this.addControls =
                    typeof this.$editableWrapper.data('use-controls') !== 'undefined'
                        ? this.$editableWrapper.data('use-controls')
                        : false;

                if (typeof $elem !== 'undefined') {
                    let isDefault = this.$editableWrapper.is('.editable--default');

                    if ($elem.is('.editable__save') || $elem.closest('.editable__save').length) {
                        if (this.requestNeeded) {
                            this.ajaxRequest(isDefault, $elem, textVal, this.$editableWrapper);
                        } else {
                            let textVal = this.$editableWrapper.find('.editable__input').val();
                            editable.addNewText(isDefault, $elem, textVal, this.$editableWrapper);
                        }
                    }
                }

                let $resetEditable = $('.editable__wrapper.js--edit:not(.editable--default)');

                $.each($resetEditable, (i, item) => {
                    let $item = $(item),
                        itemRequestNeeded = $item.is('.editable__request'),
                        itemAddControls =
                            typeof $item.data('use-controls') !== 'undefined' ? $item.data('use-controls') : false,
                        textVal = $item.find('.editable__input').val();

                    if (!itemRequestNeeded && !itemAddControls) {
                        let textVal = $item.find('.editable__input').val();
                        this.addNewText(false, $item, textVal, $item);
                    } else if (itemRequestNeeded && !itemAddControls) {
                        this.ajaxRequest(false, $item, textVal, $item);
                    }

                    $item.removeClass('js--edit').find('form').remove();
                    $item.find('.editable__toggle, .editable__text').show();
                });
            },
            ajaxRequest(isDefault, $this, textVal, $wrapper) {
                this.$editable = $wrapper.find('.editable__text');
                this.link = this.$editable.attr('data-editable-link'); // real link
                $.ajax({
                    url: this.link + textVal,
                    type: 'GET',
                    success: function (data) {
                        let editText = $.Event('edit:saveOnRequest');
                        $(document).trigger(editText, [$this, isDefault]);

                        if (data !== '' && data.text !== undefined) {
                            textVal = data.text;
                        }
                        editable.addNewText(isDefault, $this, textVal, $wrapper);
                    },
                });
            },
            addNewText(isDefault, $this, textVal, $wrapper) {
                this.$editable = $wrapper.find('.editable__text');
                this.$editable.html(textVal);

                let addingText = $.Event('edit:added');
                $(document).trigger(addingText, [$this, isDefault]);

                if (isDefault) {
                    $wrapper.removeClass('editable--default').find('form').remove();
                    $wrapper.find('.editable__toggle, .editable__text').css('display', 'inline');
                }
            },
            resetData($elem) {
                let $resetEditable = $('.editable__wrapper.js--edit'),
                    isDefault = $resetEditable.is('.editable--default');

                if (isDefault) {
                    this.$editableWrapper.find('.editable__input').val('');
                }
                const resetText = $.Event('edit:reset');
                $(document).trigger(resetText, [$elem, isDefault]);

                if (!isDefault) {
                    $resetEditable.removeClass('js--edit').find('form').remove();
                    $resetEditable.find('.editable__toggle, .editable__text').show();
                }
            },
        };
    UX.editable = editable; // add to global namespace

    $(document).ready(function () {
        if ($('.editable__text').length) {
            UX.editable.init();
        }
    });
})();
